export default __webpack_public_path__ + "static/media/Background_00118.d60d19ec.png";